import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { View } from 'foundations-components/components/View';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { getShowAllErrors, setErrorMessages } from '../../state/errorMessagesSlice';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
const AcknowledgementCheckbox = ({
  children
}) => {
  const {
    formState,
    dispatch
  } = usePaymentFormContext();
  const reduxDispatch = useDispatch();
  const loading = formState.isCheckoutSubmitPending;
  const showAllErrors = useSelector(getShowAllErrors);
  const merchantTermsOfServiceAcknowledged = formState.merchantTermsOfServiceAcknowledged;
  const isError = showAllErrors && !merchantTermsOfServiceAcknowledged;
  useEffect(() => {
    reduxDispatch(setErrorMessages({
      merchantTermsNotAcknowledged: {
        isError
      }
    }));
  }, [isError, reduxDispatch]);
  const errorMessage = useGetErrorMessagesAndTranslations().get('merchantTermsNotAcknowledged');
  const handleAcknowledgementChanged = useCallback(event => {
    dispatch({
      type: 'setMerchantTermsOfServiceAcknowledged',
      data: event.target.checked
    });
  }, [dispatch]);
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "400",
    as: "div",
    children: /*#__PURE__*/_jsx(FormControl, {
      required: true,
      error: isError,
      validationMessage: isError && errorMessage,
      children: /*#__PURE__*/_jsx(Checkbox, {
        color: "icon-interactive-default",
        size: "small",
        checked: merchantTermsOfServiceAcknowledged,
        onChange: handleAcknowledgementChanged,
        disabled: loading,
        children: children
      })
    })
  });
};
export default AcknowledgementCheckbox;